// src/pages/EditarDisciplina.jsx

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "../styles/CadastroCliente.css";
import "../styles/global.css";

const EditarDisciplina = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    codigo: "",
    nome: "",
    ementa: ""
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    axios.get(`/api/disciplinas/${id}`)
      .then((response) => {
        setFormData(response.data);
      })
      .catch((error) => {
        console.error("Erro ao buscar dados da disciplina:", error);
        alert("Erro ao carregar os dados da disciplina.");
        navigate("/disciplinas");
      });
  }, [id, navigate]);

  const validar = () => {
    const novosErros = {};

    if (!formData.codigo.trim()) {
      novosErros.codigo = "Código é obrigatório.";
    }

    if (!formData.nome.trim()) {
      novosErros.nome = "Nome é obrigatório.";
    }

    return novosErros;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const novosErros = validar();
    if (Object.keys(novosErros).length > 0) {
      setErrors(novosErros);
      return;
    }

    try {
      const payload = {
        ...formData,
        usuario_id: parseInt(localStorage.getItem("user_id"), 10) // 👈 Aqui adicionamos o usuário logado
      };
      
      const response = await axios.put(`/api/disciplinas/${id}`, payload);
      
      if (response.status === 200) {
        alert("Disciplina atualizada com sucesso.");
        navigate("/disciplinas");
      } else {
        alert("Erro inesperado ao atualizar a disciplina.");
      }
    } catch (error) {
      console.error("Erro ao atualizar disciplina:", error);

      if (error.response && error.response.data) {
        if (typeof error.response.data === "string") {
          alert(error.response.data);
        } else if (error.response.data.erro) {
          alert(error.response.data.erro);
        } else if (error.response.data.mensagem) {
          alert(error.response.data.mensagem);
        } else {
          alert("Erro ao atualizar disciplina.");
        }
      } else {
        alert("Erro ao atualizar disciplina.");
      }
    }
  };

  const handleCancelar = () => {
    navigate("/disciplinas");
  };

  return (
    <div className="form-wrapper">
      <h2 className="form-title">Editar Disciplina</h2>

      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group" style={{ width: '250px', flex: 'none' }}>
            <label htmlFor="codigo">Código</label>
            <input
              type="text"
              id="codigo"
              name="codigo"
              value={formData.codigo}
              onChange={handleChange}
            />
            {errors.codigo && <p className="erro-validacao">{errors.codigo}</p>}
          </div>

          <div className="form-group">
            <label htmlFor="nome">Nome</label>
            <input
              type="text"
              id="nome"
              name="nome"
              value={formData.nome}
              onChange={handleChange}
            />
            {errors.nome && <p className="erro-validacao">{errors.nome}</p>}
          </div>
        </div>

        <div className="form-group form-group-full">
          <label htmlFor="ementa">Ementa</label>
          <textarea
            id="ementa"
            name="ementa"
            rows="6"
            value={formData.ementa || ""}
            onChange={handleChange}
            style={{ resize: "vertical", fontSize: "0.7rem", fontFamily: "Arial, sans-serif", padding: "8px" }}
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="btn btn-primary">Salvar</button>
          <button type="button" className="btn btn-secondary" onClick={handleCancelar}>Cancelar</button>
        </div>
      </form>
    </div>
  );
};

export default EditarDisciplina;